<div class="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-md animate-fade-in"
    (click)="onClose()">

    <div class="bg-white dark:bg-slate-800 w-full max-w-2xl max-h-[90vh] rounded-[2.5rem] shadow-2xl flex flex-col relative animate-fade-in-up z-[110] overflow-hidden"
        (click)="onClickInsideModal($event)">

        <!-- Header -->
        <div class="px-8 py-6 border-b border-slate-100 flex items-center justify-between bg-white sticky top-0 z-20">
            <div class="flex items-center gap-4">
                <div class="w-12 h-12 rounded-2xl bg-amber-50 flex items-center justify-center text-amber-500">
                    <span class="material-icons text-2xl">local_parking</span>
                </div>
                <div>
                    <h2 class="text-xl font-black text-slate-800 tracking-tight">
                        {{ data ? 'แก้ไขประเภทที่จอดรถ' : 'เพิ่มประเภทที่จอดรถ' }}
                    </h2>
                    <p class="text-[10px] font-black text-slate-400 uppercase tracking-widest mt-0.5">Parking Type
                        Information</p>
                </div>
            </div>

            <div class="flex items-center gap-3">
                <button (click)="onClose()"
                    class="px-6 py-2.5 rounded-xl text-slate-500 font-bold hover:bg-slate-100 transition-all text-xs">ยกเลิก</button>
                <button (click)="onSave()" [disabled]="isLoading"
                    class="px-8 py-2.5 bg-amber-400 hover:bg-amber-500 text-white font-black rounded-xl shadow-lg hover:-translate-y-0.5 transition-all flex items-center gap-2 text-xs">
                    <span *ngIf="isLoading"
                        class="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span>
                    บันทึกข้อมูล
                </button>
            </div>
        </div>

        <!-- Form Area -->
        <div class="flex-1 overflow-y-auto p-12 custom-scrollbar">
            <div class="max-w-[400px] mx-auto space-y-8">
                <!-- <h3
                    class="text-xs font-black text-amber-600 uppercase tracking-widest border-l-4 border-amber-400 pl-3">
                    ข้อมูลพื้นฐาน
                </h3> -->

                <div class="space-y-6">
                    <div>
                        <label
                            class="text-[11px] font-black text-slate-400 uppercase tracking-widest pl-1 mb-1.5 block">
                            ชื่อประเภท (Name)
                        </label>
                        <input type="text" [(ngModel)]="formData.name"
                            placeholder="เช่น เลือกประเภท รถยนต์, จักรยานยนต์"
                            class="w-full h-11 px-4 bg-slate-50 border border-slate-100 rounded-xl text-sm font-bold focus:bg-white focus:ring-4 focus:ring-amber-50 transition-all outline-none">
                    </div>

                    <div>
                        <label
                            class="text-[11px] font-black text-slate-400 uppercase tracking-widest pl-1 mb-1.5 block">
                            ประเภทรถ (Vehicle Type)
                        </label>
                        <div class="relative">
                            <div class="relative flex items-center">
                                <input type="text" [(ngModel)]="searchVehicleTypeText"
                                    placeholder="เลือกหรือพิมพ์ค้นหาประเภทรถ..." (focus)="onInputFocus('vehicleType')"
                                    (click)="onInputFocus('vehicleType'); $event.stopPropagation()"
                                    (blur)="closeDropdowns()"
                                    class="w-full h-11 px-4 pr-10 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 rounded-xl text-sm font-bold text-slate-700 dark:text-slate-200 focus:bg-white dark:focus:bg-slate-800 focus:ring-4 focus:ring-amber-50 dark:focus:ring-amber-900/30 outline-none transition-all placeholder:font-normal placeholder:text-slate-400">
                                <span
                                    class="material-icons text-slate-400 text-sm absolute right-4 transition-transform pointer-events-none cursor-pointer"
                                    [class.rotate-180]="openDropdown==='vehicleType'">expand_more</span>
                            </div>
                            <div *ngIf="openDropdown === 'vehicleType'" (mousedown)="$event.preventDefault()"
                                class="absolute top-full left-0 right-0 mt-2 z-30 bg-white rounded-xl shadow-xl border border-slate-100 py-2 animate-fade-in-up max-h-48 overflow-y-auto">
                                <div *ngIf="filteredVehicleTypeOptions.length === 0"
                                    class="px-4 py-3 text-sm text-slate-400 text-center font-bold">ไม่พบข้อมูลที่ค้นหา
                                </div>
                                <div *ngFor="let t of filteredVehicleTypeOptions" (click)="selectVehicleType(t)"
                                    class="px-4 py-2.5 text-sm font-bold hover:bg-amber-50 hover:text-amber-600 cursor-pointer transition-all">
                                    {{ t }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="pt-4">
                        <div (click)="formData.isOnline = !formData.isOnline"
                            class="h-11 px-4 bg-slate-50 hover:bg-white border border-slate-100 rounded-xl flex items-center gap-4 cursor-pointer select-none transition-all shadow-sm">
                            <div class="w-6 h-6 rounded-lg flex items-center justify-center transition-all border"
                                [ngClass]="formData.isOnline ? 'bg-amber-500 border-amber-500 text-white' : 'bg-white border-slate-200 text-transparent'">
                                <span class="material-icons text-sm font-black">check</span>
                            </div>
                            <span class="text-xs font-black text-slate-500 uppercase tracking-widest mt-0.5">
                                เปิดใช้งาน (Online)
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>